module.exports = __webpack_public_path__ + "static/media/carbnb.ba505e05.svg";